import React from "react";
import { IKO, ikoTextForTheme } from "./tokens";
import { useTheme } from "./ThemeContext";

// D81 · member review ratings: a solid diamond in the event's main iko colour.
// Never a star, never Kili, never Poppins 800, so it cannot pass for the watu wako score.
export const Diamond = ({ color, size = 16, filled = true }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M12 3 L21 12 L12 21 L3 12Z" fill={filled ? color : "none"} stroke={color} strokeWidth={filled ? 0 : 1.5} />
  </svg>
);

export const MemberRatingPill = ({ value, iko, testId, large = false }) => {
  const { theme } = useTheme() || {};
  const key = IKO[iko] ? iko : "sherehe";
  const fill = IKO[key].bright;
  return (
    <span data-testid={testId} style={{ display: "inline-flex", alignItems: "center", gap: large ? 8 : 4,
            padding: large ? "6px 14px" : "2px 8px",
            borderRadius: 999, border: `1.5px solid ${fill}`, color: ikoTextForTheme(key, theme),
            fontFamily: "Arial", fontSize: large ? 20 : 13, fontWeight: 700, whiteSpace: "nowrap" }}>
      <Diamond color={fill} size={large ? 26 : 16} /> {value == null ? "" : Number(value).toFixed(1)}
    </span>
  );
};
